import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ children }) => (
  <div className={'h-5 primary flex fd-row ai-center jc-between'}>{children}</div>
);

Header.propTypes = {
  children: PropTypes.array,
};

export default Header;
